import { forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconMicrosoftDynamicsSales = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 26 26"
    data-fill-none
  >
    <path
      d="M10.6152 23.0769C15.9681 23.0769 20.3075 18.7375 20.3075 13.3846C20.3075 8.03172 15.9681 3.69232 10.6152 3.69232C5.26225 3.69232 0.922852 8.03172 0.922852 13.3846C0.922852 18.7375 5.26225 23.0769 10.6152 23.0769Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.0057 12.8438C23.0526 12.4371 23.0768 12.0236 23.0768 11.6044C23.0768 5.70525 18.2946 0.923065 12.3955 0.923065C11.9763 0.923065 11.5627 0.947214 11.1561 0.994195C10.8381 1.12998 10.6152 1.44555 10.6152 1.81318V13.3846H22.1867C22.5543 13.3846 22.8699 13.1617 23.0057 12.8438Z"
      fill="white"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10.6152 7.84616H15.3016C15.7722 7.84616 16.1537 8.22765 16.1537 8.69823V13.3846H10.6152V7.84616Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </SvgIcon>
));
